import * as React from "react";
import { HoverableImage } from "../../components/HoverableImage/HoverableImage";
import { toBrancusiPhotos } from "../../constants/photos";
import styles from "./ToBrancusi.module.css";

const ToBrancusi = () => {
  const gallery = toBrancusiPhotos.map((image) => (
    <HoverableImage
      src={image.src}
      infoTitle={image.infoTitle}
      infoDescription={image.infoDescription}
      isHalfImg={image.isHalfImg}
      isFullWidth={image.isFullWidth}
    />
  ));

  return (
    <>
      <h2 className={styles.title}>To Brancusi...</h2>
      <p className={styles.description}>
        To Brâncuși is a cultural fashion collection inspired by Constantin Brâncuși’s pursuit of essence, movement and the symbolic potential of material. Beginning with the physical and cultural properties of cloth, the collection developed through curved, sinuous shapes, controlled volumes and experimental pattern cutting. Rather than applying a fixed concept onto fabric, the process allowed material, weight, drape and structure to guide the form. Developed as my final university collection, it became the foundation of my practice, bringing together cultural research, craftsmanship and fashion design. The collection later became the focus of a cultural heritage exhibition, followed by a further exhibition in London, while selected pieces were created for private clients.
      </p>
      <div className={styles.galleryContainer}>
        <div className={styles.desktopGalleryContainer}>{gallery}</div>
        <div className={styles.mobileGalleryContainer}>{gallery}</div>
      </div>
      <p className={styles.description}>
        Photography: Roxana Georgesu
      </p>
      <p className={styles.description}>
        Models & Make-up: Maria Neagu & Teodora Gheorghe
      </p>
      <p className={styles.description}>
        Creative direction & Designs: Flavia Nistor
      </p>
    </>
  );
};

export default ToBrancusi;
